import React, { useState } from 'react';

const Statistics = () => {
    return (
        <div>
            Statistics
        </div>
    );
};

export default Statistics;